// ------------------------------------------------------------------------------
// name: video
// author: mudas
// created: 2025/2/12
// ------------------------------------------------------------------------------

// 检测常见的视频格式
export const isVideoFile = (fileName?: string) => {
  const reg = /\.(mp4|avi|rmvb|rm|asf|divx|mpg|mpeg|wmv|3gp|mov|flv|mkv|vob|webm)$/i;
  return fileName && reg.test(fileName);
};

export const isMp4 = (fileName: string) => {
  const reg = /\.mp4$/i;
  return reg.test(fileName);
};
export const isMov = (fileName: string) => {
  const reg = /\.mov$/i;
  return reg.test(fileName);
};
